module.exports = __webpack_public_path__ + "img/tensorflow.772fd920.webp";